import React from 'react';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router';
import { resetUserSession } from './AuthService';
import {severProperties} from './utility/Constants';
function HeaderMenu(Props) {

  const navigate = useNavigate();

  const doUserLogOut = async (e,logout)=> {
    e.preventDefault();
      if(logout==="logout")
      {
      const token = sessionStorage.getItem('refreshtoken'); // Replace with your actual token
      const apiUrl = [severProperties.serverURL,"/auth/logout"].join("");
      fetch(apiUrl, {
        method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            'Access-Control-Allow-Origin': severProperties.serverCORS,
          },
      })
        .then((response) => { resetUserSession();navigate('/'); } )
        .catch((error)=>{
         })
      }
    };

  return (
    <div className="bg-body-tertiary header-background" sticky="top" style={{width: '100%','display': 'flex',justifyContent: 'space-between'   }}>
    <table>
    <tbody>
      <tr>
        <td  style={{backgroundColor:'white',paddingLeft:5,paddingRight:5}}><div className='header-logo'></div></td>
        <td><b> <span style={{ fontSize: 24,marginLeft:'1vw',marginTop:'3vw',marginBottom:'3vw'}}>{<FormattedMessage id="patientPortal" />}</span></b>
        </td>
      </tr>
      </tbody>
      </table>
        
          <LogoutOutlinedIcon  onClick={(e,logout)=>doUserLogOut(e,'logout')} style={{marginRight:'2vw',marginTop:'5',marginBottom:'5',width:30,height:30}}/>
    </div>
    
  )
}
export default HeaderMenu;